import { render, staticRenderFns } from "./Details.vue?vue&type=template&id=a2c53b8c"
import script from "./Details.vue?vue&type=script&lang=js"
export * from "./Details.vue?vue&type=script&lang=js"
import style0 from "./Details.vue?vue&type=style&index=0&id=a2c53b8c&prod&lang=css"
import style1 from "./Details.vue?vue&type=style&index=1&id=a2c53b8c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports